<mat-card class="main-container">
    <div class="img"></div>
    <div>
        <h1 class="title">404</h1>
        <h4 class="header">{{ "dtmUi.pageNotFound.header" | transloco }}</h4>
        <p class="message">{{ "dtmUi.pageNotFound.message" | transloco }}</p>
        <button class="button-primary" type="button" routerLink="/">
            {{ "dtmUi.pageNotFound.backToDashboardLabel" | transloco }}
        </button>
    </div>
</mat-card>
